module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-program is-logged-in",
    class: ('t-program-page-' + _vm.program.id)
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$tc('web.program.nav_space', _vm.programs.length),
      "hideAuxNavOnDesktop": _vm.programs.length <= 1,
      "backButton": _vm.showBackButton()
    }
  }), _vm._v(" "), (!_vm.access_denied) ? _c('main', {
    staticClass: "o-program__main"
  }, [_c('section', {
    staticClass: "c-card c-card--program-header t-program-header qa-program-header"
  }, [_c('div', {
    staticClass: "c-card--program-header__visual"
  }, [(_vm.programLogo !== false) ? _c('img', {
    attrs: {
      "src": _vm.programLogo,
      "alt": _vm.$t('web.program.alt_text_logo'),
      "srcset": _vm.programImages[_vm.program.id].program + ' 430w, ' +
        _vm.programImages[_vm.program.id].program_860 + ' 860w'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--program-header__info t-program__info"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.program.name))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--program-header__info__desc t-program__info__desc"
  }, [_vm._v(_vm._s(_vm.program.description))])])]), _vm._v(" "), _vm._l((_vm.program.program_layout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id],
        "loaded": _vm.cardsLoaded.includes(card.id)
      }
    }) : _vm._e()]
  })], 2) : _c('main', {
    staticClass: "o-program__main"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.$t('web.program.no_access')))])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f73fd78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Program.vue
// module id = 522
// module chunks = 1